import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { heightContentAnimation, visibleContentAnimation } from 'src/app/animations';
import { FormsModule } from '@angular/forms';

declare var servicesIncludeUtils: any;

@Component({
  templateUrl: './test-cita.component.html',
  selector: 'test-cita',
  animations: [visibleContentAnimation, heightContentAnimation]
})


export class TestCitaComponent implements OnInit {
  code: string = '03340MS';

  constructor(private router: Router, private route: ActivatedRoute) { }


  ngOnInit() {

  }

  testCita() {
    servicesIncludeUtils.execute("bookingAppointment", this.code,
      {
        domain: 'https://www.seat.es',
        searchPlate: '1111AAA',
        odometer: 10000,
        modelAge: 1,
        budgetId: 'test-1234567890',
        noLogin: true,
        servicesUnique: "mantenimiento",
        sourceAppointment: "calculadora-mantenimiento"
      });
  }
}


